module.exports = __webpack_public_path__ + "img/lot-03.b81872f7.webp";